import { render } from "./EventRichTextBlock.vue?vue&type=template&id=2e2eb1d4&scoped=true"
import script from "./EventRichTextBlock.vue?vue&type=script&lang=js"
export * from "./EventRichTextBlock.vue?vue&type=script&lang=js"

import "./EventRichTextBlock.vue?vue&type=style&index=0&id=2e2eb1d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2eb1d4"]])

export default __exports__